import { CATALOG_LAZY_VARIANTS } from 'App/featuresFlags';
import useGetTags from '../useGetTags';

function useHasCatalogLazyVariants(): boolean {
  const tags = useGetTags();
  return tags.includes(CATALOG_LAZY_VARIANTS);
}

export default useHasCatalogLazyVariants;
